export default __webpack_public_path__ + "static/2101-ba70964e2a0276430e548b0ddb4e6ca0.jpeg";